'use strict';
SideBarController.$inject = ['$scope', '$element', '$timeout'];
DECISYON.ng.register.controller('sideBarCtrl', ($scope, $element, $timeout) => new SideBarController($scope, $element, $timeout));
